import { render, staticRenderFns } from "./password_trans.vue?vue&type=template&id=5a77eb26&scoped=true"
import script from "./password_trans.vue?vue&type=script&lang=js"
export * from "./password_trans.vue?vue&type=script&lang=js"
import style0 from "./password_trans.vue?vue&type=style&index=0&id=5a77eb26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77eb26",
  null
  
)

export default component.exports